const mappings: Record<
  string,
  {
    path: string;
    user: string;
    merchant: string;
    store: string;
  }[]
> = {
  "05fzRBj3xQYZOuEv9fUkJqFq25r2": [
    {
      user: "Sbd4UZlKtiXv26vLXkdiPdNr6un1",
      merchant: "merchant.YnZAcGF5by5jb20uYXU=",
      store: "store.ST32C39223229T5P8P52Q3PDB",
      path: "/users/Sbd4UZlKtiXv26vLXkdiPdNr6un1/merchants/merchant.YnZAcGF5by5jb20uYXU=/stores/store.ST32C39223229T5P8P52Q3PDB",
    },
    // {
    //   user: "IVmbDmDtNYMNrBdJLFav6stj4XD3",
    //   merchant: "merchant.eWludGdyb3VwQHBheW8uY29tLmF1",
    //   store: "store.ST32B6222322BQ5PX6MRPDKLW",
    //   path: "/users/IVmbDmDtNYMNrBdJLFav6stj4XD3/merchants/merchant.eWludGdyb3VwQHBheW8uY29tLmF1/stores/store.ST32B6222322BQ5PX6MRPDKLW",
    // },
  ],
  RSdxuaqVU8Q8UCpKHu2WPQByv6Q2: [
    // {
    //   user: "Sbd4UZlKtiXv26vLXkdiPdNr6un1",
    //   merchant: "merchant.YnZAcGF5by5jb20uYXU=",
    //   store: "store.ST32C39223229T5P8P52Q3PDB",
    //   path: "/users/Sbd4UZlKtiXv26vLXkdiPdNr6un1/merchants/merchant.YnZAcGF5by5jb20uYXU=/stores/store.ST32C39223229T5P8P52Q3PDB",
    // },
    {
      user: "IVmbDmDtNYMNrBdJLFav6stj4XD3",
      merchant: "merchant.eWludGdyb3VwQHBheW8uY29tLmF1",
      store: "store.ST32B6222322BQ5PX6MRPDKLW",
      path: "/users/IVmbDmDtNYMNrBdJLFav6stj4XD3/merchants/merchant.eWludGdyb3VwQHBheW8uY29tLmF1/stores/store.ST32B6222322BQ5PX6MRPDKLW",
    },
  ],

  uFaKfKZW3ac0TOqDvOiQ0rhvrKi2: [
    {
      user: "IVmbDmDtNYMNrBdJLFav6stj4XD3",
      merchant: "merchant.eWludGdyb3VwQHBheW8uY29tLmF1",
      store: "store.ST32B5X22322BQ5PZLW2J3LJF",
      path: "/users/IVmbDmDtNYMNrBdJLFav6stj4XD3/merchants/merchant.eWludGdyb3VwQHBheW8uY29tLmF1/stores/store.ST32B5X22322BQ5PZLW2J3LJF",
    },
  ],

  iNAZI48U3ZdSlwLzjzFSQLFCrmp1: [
    {
      user: "w71AKknYYzeimJcJsRpwM04JsXA3",
      merchant: "merchant.bGZzYXVAcGF5by5jb20uYXU=",
      store: "store.ST329Z522322BQ5Q25MR2DXLG",
      path: "/users/w71AKknYYzeimJcJsRpwM04JsXA3/merchants/merchant.bGZzYXVAcGF5by5jb20uYXU=/stores/store.ST329Z522322BQ5Q25MR2DXLG",
    },
  ],
  P0XcbOywFoNiKncLD9YY1GlK7AT2: [
    {
      user: "e04ZZ9STVvQbkJYpg8IpBSOl2UD3",
      merchant: "merchant.YnBhdUBwYXlvLmNvbS5hdQ==",
      store: "store.ST32DDL22322BQ5Q25L4Q24BK",
      path: "/users/e04ZZ9STVvQbkJYpg8IpBSOl2UD3/merchants/merchant.YnBhdUBwYXlvLmNvbS5hdQ==/stores/store.ST32DDL22322BQ5Q25L4Q24BK",
    },
  ],
};

const storeToName: Record<string, string> = {
  ST32C39223229T5P8P52Q3PDB: "Site 1",
  ST32B6222322BQ5PX6MRPDKLW: "Site 2",
  ST32B5X22322BQ5PZLW2J3LJF: "Site 3",
  ST329Z522322BQ5Q25MR2DXLG: "Site 4",
  ST32DDL22322BQ5Q25L4Q24BK: "Site 5",
};

export const getStoreName = (storeId: string): string => {
  return storeToName[storeId.replace("store.", "")] || "Unknown Site";
};
export const getUserMapping = (
  userId: string,
): {
  path: string;
  user: string;
  merchant: string;
  store: string;
}[] => {
  return mappings[userId] || [];
};
